<template>
  <section>
    <div class="header_wrap">
      <img src="/static/images/relogo.png" alt="">
    </div>
    <div class="content_wrap">
      <div class="content_box">
        <img src="/static/images/jihuo.png" alt="">
        <p class="p_status">注册激活成功</p>
        <p class="p_tip">恭喜您完成了智慧安全生产管理平台的注册与激活，登录后即可开始使用</p>
        <p class="p_title">运筹于握中，安全管控行</p>
        <p class="p_btn"><span>立即登录</span></p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'actionPage',
  data () {
    return {
      
    }
  },
  created(){

  },
  methods:{

  }
}
</script>
<style lang="less" scoped>
.header_wrap{
  width: 100%;
  background: #ffffff;
  height: 144px;
  position: relative;
  img{
    position: absolute;
    height: 71px;
    width: 233px;
    left: 9.7%;
    top: 25%;
  }
}
.content_wrap{
  width: 100%;
  padding: 40px;
  background: #F5F5F5;
  .content_box{
    width: 71.5%;
    height: 790px;
    margin: 0 auto;
    background: #ffffff;
    text-align: center;
    img{
      width: 197px;
      margin: 116px 0 26px;
    }
    .p_status{
      color: #333333;
      line-height: 46px;
      font-size: 32px;
      font-weight: 500;
    }
    .p_tip{
      color: #333333;
      line-height: 30px;
      font-size: 22px;
      margin: 0 0 40px;
    }
    .p_title{
      color: #333333;
      line-height: 30px;
      font-size: 26px;
      line-height: 38px;
      margin: 20px 0 30px;
      font-weight: 500;
    }
    .p_btn{
      color: #333333;
      line-height: 46px;
      font-size: 32px;
      font-weight: 500;
      span{
        display: inline-block;
        width: 224px;
        height: 70px;
        line-height: 70px;
        background: #4566F5;
        border-radius: 9px;
        color: #ffffff;
        font-size: 22px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/actionPage.vue